export const INVOICE_STATUSES = [
    { id: 1, name: 'Заказ создан' },
    { id: 2, name: 'Забирается курьером' },
    { id: 3, name: 'Груз забран у отправителя' },
    { id: 4, name: 'Забор груза отменён' },
    { id: 5, name: 'Обработка груза на складе' },
    { id: 6, name: 'Груз обработан и ожидает отправку' },
    { id: 7, name: 'Груз в пути' },
    { id: 8, name: 'Груз в городе назначения' },
    { id: 9, name: 'Доставляется курьером' },
    { id: 10, name: 'Доставлен' },
    { id: 11, name: 'Доставка отменена получателем' },
    // { id: 12, name: 'Доставляется в ПВЗ' },
    // { id: 13, name: 'Доставлен в ПВЗ' },
    // { id: 14, name: 'Забран получателем из ПВЗ' },
]

export const INVOICE_BILLING = [
    { id: 1, name: 'Да', value: '1' },
    { id: 2, name: 'Нет', value: '0' },
]

export const INVOICE_CALCULATION = [
    { id: 20, name: 'Вычисление создано' },
    { id: 21, name: 'Транскрипт создан' },
]

export const HIDE_DOP_INVOICES_OPTIONS = [
    { id: 0, name: 'Да', key: '0' },
    { id: 1, name: 'Нет', key: '1' },
]

export const SELF_DELIVERY_OPTIONS = [
    { id: 1, name: 'Да', key: '1' },
    { id: 0, name: 'Нет', key: '0' },
]

export const PICKUP_OPTIONS = [
    { id: 1, name: 'Да', key: '1' },
    { id: 0, name: 'Нет', key: '0' },
]

export const INVOICE_CANCEL = [
    { id: 1, name: 'Да', value: '1' },
    { id: 2, name: 'Нет', value: '0' },
]

export const INVOICE_PAYMENT_METHODS = [
    { id: 1, name: 'Банковской картой' },
    { id: 2, name: 'Наличными' },
    { id: 3, name: 'Перечислением на счет' },
    { id: 4, name: 'KaspiPay' },
]

export const INVOICE_ADDITIONAL_SERVICES = [
    { id: 1, name: 'Да', value: '1' },
    { id: 2, name: 'Нет', value: '0' },
]

export const INVOICE_ADDITIONAL_SERVICES_EXTENDED = [
    'loader',
    'manipulator',
    'crane',
    'hydraulic_trolley',
]

export const INVOICE_ADDITIONAL_SERVICES_TMC = [4, 5, 6]

export const INVOICE_ADDITIONALL_SERVICES_EXTENDED_BLOCKS = [
    { key: 'carrier_name', name: 'Поставщик' },
    { key: 'cost_per_hour', name: 'Себестоимость за час' },
    { key: 'value', name: 'Кол-во' },
    { key: 'paid_price_total', name: 'Итоговое выставление клиенту' },
    { key: 'duration', name: 'Затраченное время' },
]

export const COMMENT_USERS_OPTIONS = [
    { id: 20, name: 'Менеджеру' },
    { id: 16, name: 'Диспетчеру' },
]

export const INVOICE_STATUSES_LO = [
    { id: 16, color: 'yellow' },
    { id: 20, color: 'red' },
    { id: 24, color: 'yellow' },
    { id: 26, color: 'yellow' },
    { id: 27, color: 'yellow' },
    { id: 29, color: 'yellow' },
    { id: 30, color: 'yellow' },
    { id: 31, color: 'yellow' },
    { id: 32, color: 'yellow' },
    { id: 33, color: 'yellow' },
    { id: 37, color: 'yellow' },
    { id: 56, color: 'yellow' },
    { id: 57, color: 'yellow' },
    { id: 58, color: 'yellow' },
    { id: 59, color: 'yellow' },
    { id: 60, color: 'yellow' },
    { id: 61, color: 'yellow' },
    { id: 62, color: 'yellow' },
    { id: 63, color: 'yellow' },
    { id: 64, color: 'yellow' },
    { id: 65, color: 'yellow' },
    { id: 66, color: 'yellow' },
]
